import { EmptyState, ErrorState, ListSkeleton } from '@atlas/ui-components'
import { Button } from '@atlas/ui-primitives'
import type { ReactNode } from 'react'

export interface ListStateProps {
	isLoading?: boolean
	isError?: boolean
	onRetry?: () => void
	isEmpty: boolean
	emptyTitle: string
	emptyDescription?: string
	/** What the list is, for the skeleton's and the failure's words. */
	noun: string
	children: ReactNode
}

/**
 * A Mappings list in its four states: a skeleton while it loads, a failure with
 * Retry (also reported in the status bar by the tab), an empty state, or the list.
 */
export function ListState({
	isLoading,
	isError,
	onRetry,
	isEmpty,
	emptyTitle,
	emptyDescription,
	noun,
	children,
}: ListStateProps) {
	if (isLoading) return <ListSkeleton rows={4} label={`Loading ${noun}`} />
	if (isError) {
		return (
			<ErrorState
				title={`Could not load the ${noun}`}
				action={
					onRetry ? (
						<Button size="sm" variant="outline" onPress={onRetry}>
							Retry
						</Button>
					) : undefined
				}
			/>
		)
	}
	if (isEmpty) return <EmptyState title={emptyTitle} description={emptyDescription} />
	return <>{children}</>
}
